import GeneratedFromAddressesApi from "./generated/GeneratedFromAddressesApi"

class FromAddressesApi extends GeneratedFromAddressesApi {

}

export const fromAddressesApi = new FromAddressesApi()
